"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.problemSchema = void 0;
var constants_1 = require("@hobt/constants");
exports.problemSchema = {
    type: 'object',
    additionalProperties: {
        not: true,
        errorMessage: '- should not have additional property ${0#}',
    },
    properties: {
        code: {
            type: ['string', 'null'],
            enum: Object.values(constants_1.ProblemCode),
            minLength: 0,
            maxLength: 8,
            errorMessage: 'Should be valid ProblemCode enum value or null',
        },
        fieldName: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 100,
            errorMessage: 'Should be a string with a maximum of 100 characters or null',
        },
        fieldValue: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 100,
            errorMessage: 'Should be a string with a maximum of 100 characters or null',
        },
        indexNumber: {
            type: ['integer', 'null'],
            maximum: 2147483647,
            minimum: -2147483647,
            errorMessage: 'Should be an integer or null',
        },
        typeCode: {
            type: ['integer', 'null'],
            enum: Object.values(constants_1.ProblemTypeCode),
            errorMessage: 'Should be a valid ProblemTypeCode enum value or null',
        },
    },
};
